import React, { useState, useEffect } from 'react';
import { X, DownloadSimple } from '@phosphor-icons/react';

export const InstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      // Only show if user hasn't dismissed before
      const dismissed = localStorage.getItem('pwa-install-dismissed');
      if (!dismissed) {
        setShowBanner(true);
      }
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      setShowBanner(false);
    }
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setShowBanner(false);
    localStorage.setItem('pwa-install-dismissed', '1');
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-20 left-4 right-4 sm:left-auto sm:right-4 sm:w-80 bg-[#161616] border border-[#0096FF]/30 rounded-xl p-4 shadow-2xl shadow-[#0096FF]/10 z-50 animate-in slide-in-from-bottom-4" data-testid="pwa-install-banner">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-lg bg-[#0096FF]/15 flex items-center justify-center flex-shrink-0">
          <DownloadSimple size={20} className="text-[#0096FF]" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-white text-sm font-semibold" style={{ fontFamily: 'Outfit' }}>Install Show Master</p>
          <p className="text-[#9E9E9E] text-xs mt-0.5">Add to your home screen for quick access and offline support</p>
          <div className="flex gap-2 mt-3">
            <button
              onClick={handleInstall}
              className="px-4 py-1.5 bg-[#0096FF] text-white text-xs font-semibold rounded-md hover:bg-[#0096FF]/80 transition-colors"
              data-testid="pwa-install-btn"
            >
              Install
            </button>
            <button
              onClick={handleDismiss}
              className="px-3 py-1.5 text-[#9E9E9E] text-xs hover:text-white transition-colors"
              data-testid="pwa-dismiss-btn"
            >
              Not now
            </button>
          </div>
        </div>
        <button onClick={handleDismiss} className="text-[#555] hover:text-white transition-colors flex-shrink-0">
          <X size={16} />
        </button>
      </div>
    </div>
  );
};
